export default {
  required:(n) => {return"Поле "+n+" обязательное"},
  max:function(n,e){return"Поле "+n+" не может быть более "+e[0]+" символов. Йо"}
}



// WEBPACK FOOTER //
// ./src/strings/validator/messages/ru.js